import React from 'react';

const StepCake = ({
  categories,
  activeCategoryId,
  setActiveCategoryId,
  cakes,
  selectedCakeId,
  selectedCake,
  onSelectCake,
  customSize,
  setCustomSize,
  customOptions = [],
  onSelectVariation,
}) => {
  const sizeOptions = customOptions;

  const filteredCakes = cakes.filter(
    (cake) => !activeCategoryId || String(cake.category_id) === String(activeCategoryId)
  );

  return (
    <section className="booking-card">
      <div className="cake-header">
        <h4 className="booking-section-title">Choose Cake (optional)</h4>
        <div className="cake-tabs">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              className={`cake-tab${activeCategoryId === cat.id ? ' active' : ''}`}
              onClick={() => setActiveCategoryId(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="cake-grid">
        {filteredCakes.length > 0 ? (
          filteredCakes.map((cake) => {
            const active = selectedCakeId === cake.id || selectedCake === cake.label;
            return (
              <button
                key={cake.id || cake.label}
                type="button"
                className={`cake-card${active ? ' active' : ''}`}
                onClick={() => onSelectCake(cake)}
              >
                {cake.img && <img src={cake.img} alt={cake.label} />}
                <span className="cake-name">{cake.label}</span>
                <span className="cake-price">{cake.price}</span>
                {active && <span className="cake-check bi bi-check-lg" />}
              </button>
            );
          })
        ) : (
          <div className="cake-note">No cakes available.</div>
        )}
      </div>

      {sizeOptions.length > 0 && (
        <div className="custom-card">
          <div className="custom-card-header">
            Customize as per requirement
            <span className="bi bi-x-lg custom-close" />
          </div>
          <div className="custom-options">
            {sizeOptions.map((opt) => (
              <label key={opt.label} className="custom-row">
                <span>{opt.label}</span>
                <span>{opt.price}</span>
                <input
                  type="radio"
                  name="customSize"
                  checked={customSize === opt.label}
                  onChange={() => {
                    setCustomSize(opt.label);
                    if (onSelectVariation) onSelectVariation(opt);
                  }}
                />
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="cake-note">
        (Note:- The cake images are provided are for representation purposes only; actual cakes may
        vary)
      </div>
    </section>
  );
};

export default StepCake;
